export default "/images/vendor/jquery-ui/themes/base/ui-icons_777777_256x240.png?961d67294deccae7cc75078cc91ea876";